<template>
  <div id="LayoutBoard" :class="{ open: isOpen }">
    <Sidebar
      :isOpen="isOpen"
      :links="sidebarLinks"
      @update:isOpen="isOpenOnDesktop = $event" />
    <div class="content">
      <div class="inner">
        <router-view @update:isOpen="isOpenOnDesktop = $event" />
      </div>
    </div>
  </div>
</template>

<script>
import BoardView from 'components/board/BoardView'
import Meta from '../mixins/Meta'
import Record from 'components/Record'
import Set from 'components/Set'
import SidebarOpen from '../mixins/SidebarOpen'
import { registerComponents } from '../utils'

export default {
  mixins: [
    Meta('Dashboard'),
    SidebarOpen,
  ],
  data() {
    return {
      sidebarLinks: [
        {
          to: 'DashboardNew',
          icon: 'apps',
          label: 'Valdymas',
        },
      ],
    }
  },
  async beforeMount() {
    registerComponents({
      BoardView,
      Record,
      Set,
    })
  },
}
</script>

<style lang="scss">
#LayoutBoard {
  background: $white-bis;
  min-height: 100%;
  padding-top: $sidebar-burger-height;
  @include sm {
    padding-left: $sidebar-width-compact;
    padding-top: 0;
  }

  > .content {
    display: flex;
    min-height: 100vh;

    > .inner {
      min-height: 100%;
      min-width: 100%;
    }
  }

  &.open {
    padding-left: $sidebar-width;
  }

  &.loading {
    height: 100%;
  }
}
</style>
